const mediaItems = [
  {
    title: '《星际征途：新纪元》',
    meta: '科幻 · 2026 · 4K',
    desc: '人类文明在浩瀚宇宙中开启全新篇章，视觉特效震撼人心。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20in%20deep%20space%20with%20warm%20golden%20nebula%20background%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20artistic%20abstract%20composition%2C%20rich%20orange%20and%20gold%20tones&width=720&height=400&seq=media-01&orientation=landscape',
    tag: '热播中',
  },
  {
    title: '《暗夜追踪者》',
    meta: '动作 · 2026 · 1080P',
    desc: '硬汉刑警跨国追凶，拳拳到肉的真实打斗场面引爆肾上腺素。',
    img: 'https://readdy.ai/api/search-image?query=Noir%20cityscape%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20dramatic%20shadows%2C%20artistic%20abstract%20composition%2C%20rich%20amber%20and%20dark%20tones%2C%20cinematic%20atmosphere&width=720&height=400&seq=media-02&orientation=landscape',
    tag: '新上线',
  },
  {
    title: '《笑傲江湖之风云再起》',
    meta: '古装 · 2026 · 4K',
    desc: '经典武侠IP全新演绎，顶级特效还原瑰丽江湖世界。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20landscape%20with%20misty%20mountains%2C%20warm%20sunset%20glow%2C%20artistic%20ink%20wash%20painting%20style%2C%20golden%20and%20coral%20tones%2C%20cinematic%20widescreen%20composition&width=720&height=400&seq=media-03&orientation=landscape',
    tag: '热门',
  },
  {
    title: '《恋恋笔记本2》',
    meta: '爱情 · 2026 · 1080P',
    desc: '跨越十年的感人爱情故事，温暖治愈每一颗疲惫的心。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20scene%20with%20soft%20warm%20lighting%2C%20artistic%20dreamy%20composition%2C%20golden%20hour%20glow%2C%20abstract%20floral%20elements%2C%20cinematic%20romance%20aesthetic&width=720&height=400&seq=media-04&orientation=landscape',
    tag: '催泪',
  },
  {
    title: '《美食大冒险》第三季',
    meta: '综艺 · 2026 · 1080P',
    desc: '走遍全球探寻极致美味，每一帧都让人垂涎欲滴的美食之旅。',
    img: 'https://readdy.ai/api/search-image?query=Gourmet%20food%20artistic%20composition%20with%20warm%20golden%20lighting%2C%20elegant%20table%20setting%2C%20abstract%20culinary%20elements%2C%20rich%20amber%20and%20terracotta%20tones%2C%20cinematic%20still%20life&width=720&height=400&seq=media-05&orientation=landscape',
    tag: '下饭',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              精彩推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              精选热门影视内容，每一部都值得你花时间
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {mediaItems.map((item, idx) => (
              <a
                key={idx}
                href="#index"
                className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-1">{item.meta}</p>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}